import { render, staticRenderFns } from "./UpdateChannel.vue?vue&type=template&id=b0f4f7c6&scoped=true"
import script from "./UpdateChannel.vue?vue&type=script&lang=js"
export * from "./UpdateChannel.vue?vue&type=script&lang=js"
import style0 from "./UpdateChannel.vue?vue&type=style&index=0&id=b0f4f7c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f4f7c6",
  null
  
)

export default component.exports